module.exports = __webpack_public_path__ + "static/media/tc.a566615d.png";